
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChevronDoubleLeftGoogle as ObiChevronDoubleLeftGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chevron-double-left-google.js';
 
 
 

 
 export const ObiChevronDoubleLeftGoogle = createComponent({
   react: React,
   tagName: 'obi-chevron-double-left-google',
   elementClass: ObiChevronDoubleLeftGoogleElement,
   events: {
     
   }
  });
 
 